import { PageDescription } from "#/components/PageDescription";
import { PageEyeBrow } from "#/components/PageEyeBrow";
import { PageHeader } from "#/components/PageHeader";
import { PageIntro } from "#/components/PageIntro";

export function ArchivePageIntro() {
  return (
    <PageIntro>
      <PageEyeBrow>Replay past maps</PageEyeBrow>
      <PageHeader>Archive</PageHeader>
      <PageDescription>
        Missed a day or two? While leaderboards only track scores posted on the correct day, you can
        still replay past maps through the premium archive. Can you beat them all?
      </PageDescription>
    </PageIntro>
  );
}
